import { useDispatch } from "react-redux";
import { AnyAction, Dispatch } from "redux";

/**
 * useDispatch typed for this store. The reducers are declared with AnyAction so the
 * app's interface-based actions dispatch without the UnknownAction index-signature check.
 */
export const useAppDispatch = () => useDispatch<Dispatch<AnyAction>>();
